import authReducer from "../views/utilities/auth/authSlice";
import proxyUser from "../views/utilities/auth/proxyUserSlice";
import userReducer from "../views/utilities/auth/userRoleSlice";
import moodReducer from "../views/utilities/auth/moooSlice";
import customizationReducer from "./customizationReducer";
import { combineReducers, configureStore } from "@reduxjs/toolkit";

import type { PreloadedState } from "@reduxjs/toolkit";
import type { Store } from "redux";
// import { leaveDetailsApi } from "../services/intranet-portal-services/services/leaveDetailsApi";
import { ticketApi } from "../services/ticket-service/api";
//= =============================|| COMBINE REDUCER ||============================== //

const rootReducer = combineReducers({
  customization: customizationReducer,
  auth: authReducer,
  proxyUser,
  user: userReducer,
  mood: moodReducer,
  // [leaveDetailsApi.reducerPath]: leaveDetailsApi.reducer,
  [ticketApi.reducerPath]: ticketApi.reducer
});

export const setupStore = (preloadedState?: PreloadedState<RootState>): Store<RootState> => {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredPaths: ["auth.user"], // Specify the path to non-serializable data
          isSerializable: (value: unknown) => true
        }
      })
        // .concat(leaveDetailsApi.middleware)
        .concat(ticketApi.middleware)
  });
};

export default rootReducer;
export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore["dispatch"];
